import {Model} from "@/services/api";

export default class Inventory extends Model {
    static relations = {
        pages: require("@/services/models/page").default,
        authors: require("@/services/models/person").default,
        persons: require("@/services/models/person").default,
    };

    static route() {
        return 'inventories';
    }
}
